import { Button, CircleCheckBigIcon, Dialog, Flex } from '@buffer-mono/popcorn'

import styles from './MonthlyCleanupSuccess.module.css'

import type { JSX } from 'react'

type MonthlyCleanupSuccessProps = {
  /** Number of comments that were resolved, shown in the heading. */
  total: number
  onClose: () => void
}

/**
 * The completion screen shared by both cleanup flows: a confirmation of how
 * many comments were resolved. Renders inside a `Dialog.Content`.
 */
export const MonthlyCleanupSuccess = ({
  total,
  onClose,
}: MonthlyCleanupSuccessProps): JSX.Element => {
  const suffix = total === 1 ? '' : 's'

  return (
    <Flex direction="column" align="center" gap="sm" className={styles.success}>
      <span className={styles.icon} aria-hidden="true">
        <CircleCheckBigIcon size={30} />
      </span>
      <Dialog.Title>
        {total} comment{suffix} resolved
      </Dialog.Title>
      <Dialog.Description className={styles.description}>
        You can access them anytime by applying the &apos;status&apos; filter.
      </Dialog.Description>
      <Button variant="primary" onClick={onClose} className={styles.close}>
        Close
      </Button>
    </Flex>
  )
}
